import Joi from "joi";

/**
 * Labels for Joi display
 */
export const MONTHLY_PRICE_LABEL = 'Monthly price';
export const ANNUAL_PRICE_LABEL = 'Annual price';

/**
 * Simple abstraction of the rules for validating name inputs.
 * Used for softwareProduct and supportAddon.
 */
export const nameSchema = Joi.string()
  .min(3)
  .max(255)
  .required()
  .label('Name')
  .messages({
    'string.base': `{#label} should not be empty.`,
    'string.empty': `{#label} should not be empty.`,
    'string.min': `{#label} should have a minimum length of {#limit}.`,
    'string.max': `{#label} should have a maximum length of {#limit}.`,
    'any.required': `{#label} is a required field.`
  });
